<template>
  <div>
    <h2 class="title white">Quem é você?</h2>
    <div v-if="error_message" class="error-panel">{{ error_message }}</div>
    <div class="ui five column grid" style="width: 1400px; height: 560px; margin: 0 auto;">
      <paginate
        name="customers"
        :list="customers"
        :per="10"
        style="border: 1px solid; display: contents;"
      >
        <div v-for="customer in paginated('customers')" :key="customer.id" class="column">
          <div :class="['option customer-photo', { inactive: is_loading }]" style="width: 220px;" @click="selectCustomer(customer)">
            <img v-show="customer.image != null" :src="$baseUrl + '/storage/' + customer.image" alt="" class="customer">
            <i v-show="customer.image == null" class="user circle icon"></i>
            <p style="margin-top: 6px;">{{ customer.name }}</p>
            <p v-if="customer.cpf">CPF {{ customer.cpf | mCPF }}</p>
          </div>
        </div>
      </paginate>
    </div>
    <div id="nenhum-btn" class="btn" @click="($emit('buttonClicked', 'TakePicture'), setCustomerName());">
      <span>Não sou eu</span>
    </div>
    <div class="footer-btn">
      <div id="back-btn" class="btn btn-cancel" @click.prevent="$emit('backClicked', 'StartPage');">
        <i class="ui sign-out icon"></i>
        <span>Cancelar</span>
      </div>
      <ul class="paginate-links customers">
        <li v-show="meta.prev" class="prev">
          <a @click.prevent="prevPage()">Voltar</a>
        </li>
        <li v-show="meta.next" class="next">
          <a @click.prevent="nextPage()">Próximos</a>
        </li>
      </ul>
    </div>
  </div>
</template>
<script>
import moment from 'moment';
export default {
  props: {
      customers: Array,
      meta: Object,
      ticket: Object
  },
  data() {
    return {
      msg: 'Por favor, toque na sua foto.',
      lang: 'pt-BR',
      paginate: ['customers'],
      is_loading: false,
      error_message: ''
    };
  },
  mounted() {
    this.speak(this.msg);
    console.log('meta', this.meta)
  },
  filters: {
    mCPF(cpf){
      cpf=cpf.replace(/\D/g,"")
      cpf=cpf.replace(/(\d{3})(\d)/,"$1.$2")
      cpf=cpf.replace(/(\d{3})(\d)/,"$1.$2")
      cpf=cpf.replace(/(\d{3})(\d{1,2})$/,"$1-$2")
      return cpf
    },
  },
  methods: {
    nextPage() {
      axios.get(this.meta.next)
      .then(({data}) => {
        console.log(data)
        this.meta = data.links;
        this.customers = data.data;
      }).catch((err) => {
        console.log(err)
      });
    },
    prevPage() {
      axios.get(this.meta.prev)
      .then(({data}) => {
        console.log(data)
        this.meta = data.links;
        this.customers = data.data;
      }).catch((err) => {
        console.log(err)
      });
    },
    speak(msg) {
      var utterThis = new SpeechSynthesisUtterance(msg);
      var voices = speechSynthesis.getVoices();
      voices.map((value, i) => {
        if (value.lang == 'pt-BR') {
        }
      });
      window.speechSynthesis.speak(utterThis);
    },
    falar() {
      let SpeechRecognition = window.SpeechRecognition || window.webkitSpeechRecognition
      let recognition = SpeechRecognition ? new SpeechRecognition() : false
      recognition.lang = this.lang;
      recognition.interimResults = true;
    },
    async selectCustomer(elem) {
      if (this.is_loading) return;
      this.is_loading = true;
      this.error_message = '';
      this.$emit('setCustomer', elem);
      if (this.ticket.attendance_type_id == 1) {
        if (elem.agreement_id == null) {
          this.$emit('buttonClicked', 'AgreementsList');
        } else {
          this.$emit('buttonClicked', 'ProfsList');
        };
      } else if (this.ticket.attendance_type_id == 2) {
        if (elem.agreement_id == null) {
          this.$emit('buttonClicked', 'AgreementsList');
        } else {
          let ticket = this.ticket;
          ticket.started_at = moment().format('Y-MM-DD HH:mm:ss');
          ticket.professional_id = null;
          ticket.name = elem.name;
          ticket.photo = elem.image;
          ticket.customer_id = elem.id;
          console.log('exame', ticket);
          try {
            await axios.post('api/kiosk/ticket', ticket);
            this.$emit('buttonClicked', 'FinishTicket');
          } catch (err) {
            this.is_loading = false;
            this.error_message = 'Não foi possível gerar o atendimento. Tente novamente.';
          }
        }
      }
      if (this.ticket.attendance_type_id == 1 || elem.agreement_id == null) {
        this.is_loading = false;
      }
    },
    setCustomerName() {

    },
    backClicked(section) {
      this.$emit('backClicked', section);
    },
  }
};
</script>
<style scoped>
@keyframes shadow-pulse
{
  0% {
    box-shadow: 0 0 0 0px rgb(255, 255, 255);
  }
  100% {
    box-shadow: 0 0 0 35px rgba(110, 110, 110, 0);
  }
}

@media only screen and (min-width: 500px) {
  .ui.five.column.grid .column {
    height: 206px;
    margin: 0 10px;
    padding-top: 10px;
    background: #56ccf2;
    border-radius: 20px;
    -webkit-box-shadow: 0px 10px 8px rgba(0, 0, 0, 0.22), 0 1px 2px rgba(0, 0, 0, 0.23);
    box-shadow: 0px 10px 8px rgba(0, 0, 0, 0.22), 0 1px 2px rgba(0, 0, 0, 0.23);
    cursor: pointer;
  }
  .customer-photo {
    margin: 0 auto;
    width: fit-content;
  }
}
h2 {
  font-size: 42px;
  font-weight: bold;
  font-family: 'Source Sans Light';
}
.row {
  padding: 1rem 3rem;
}
.ui.grid .column {
  height: 276px !important;
  padding: 20px;
  margin-bottom: 20px !important;
  text-align: center;
}

.ui.grid .column p {
  color: #fff;
  font-weight: bold;
  margin: 0px;
  font-size: 1.2em;
}
.customer-photo i {
  width: 100%;
  font-size: 180px;
  line-height: 180px;
  color: #fff;
}
.ui.grid .column img {
  width: 180px;
  height: 180px;
  border-radius: 500px;
  border: 5px solid #fff;
}
.arrow-buttons {
  position: absolute;
  bottom: 20px;
  width: 100%;
  padding: 0px 42px;
  font-size: 64px;
  color: #fff;
}
.arrow-buttons i {
  color: #56ccf2;
  cursor: pointer;
}
.footer-btn {
  position: fixed;
  bottom: 16px;
  padding: 0px 20px;
}
.btn {
  display: flex;
  width: 180px;
  height: 60px;
  align-items: center;
  font-size: 26px;
  border-radius: 500px;
  background-color: rgb(255, 255, 255);
  box-shadow: 0 3px 6px rgba(0, 0, 0, 0.16), 0 1px 2px rgba(0, 0, 0, 0.23);
  cursor: pointer;
}
.btn span {
  width: inherit;
}
#nenhum-btn {
  width: 320px;
  height: 100px;
  margin: 0 auto;
  margin-top: 50px;
  font-size: 42px;
  color: #555;
  box-shadow: 0px 10px 8px rgba(0, 0, 0, 0.22), 0 1px 2px rgba(0, 0, 0, 0.23);
  animation: shadow-pulse 1s infinite;
}
#nenhum-btn span {
  width: fit-content;
  margin: 0 auto;
}
</style>



// WEBPACK FOOTER //
// src/components/CustomerIdent.vue